import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 40px 0;

  ${up('sm')} {
    padding: 64px 0;
  }
`

const Intro = styled.div`
  padding: 30px 0 30px 0;

  ${up('sm')} {
    padding: 64px 0 64px 0;
  }
`

const Title = styled.h1`
  font-size: 26px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;

  ${up('sm')} {
    font-size: 26px;
    line-height: 30px;
  }
`

const UpdatedAt = styled.p`
  margin: 0;
  color: #0078c9;
  text-align: center;
`

const Section = styled.div`
  padding: 14px 0;

  ${up('sm')} {
    padding: 20px 0;
  }
`
const Statement = styled.p`
  color: #757d88;
  font-size: 16px;
  line-height: 28px;
  text-align: justify;

  :last-of-type {
    margin: 0;
  }
`

const Text = styled.p`
  color: #22262a;
  font-size: 16px;
  line-height: 28px;
  text-align: justify;

  :last-of-type {
    margin: 0;
  }
`

export const PrivacyPolicy: ComponentType = () => (
  <Wrapper>
    <Container>
      <Row className="justify-content-center">
        <Col md={8}>
          <Intro>
            <Title>Aviso de Privacidad</Title>
            <UpdatedAt>Actualizados el 22 de julio de 2019</UpdatedAt>
          </Intro>
        </Col>
        <Col md={8}>
          <Section>
            <Statement>
              <strong>BIENES RAÍCES YUCATÁN PREMIER S.A. DE C.V.</strong> es una empresa constituida bajo las leyes
              mexicanas, creada en fecha veinticuatro de agosto del año dos mil diez en acta número ochocientos
              diecinueve, ante la fe del notario público ochenta y nueve en la ciudad de Motúl, Yucatán, registrado en
              la secretaría de Hacienda y Crédito Público con el Registro Federal de Contribuyentes número BRY100824QA8
              y con domicilio ubicado en el predio marcado con el número 248 de la calle 22 entre 27-A del
              fraccionamiento Monterreal, de la ciudad de Mérida, Yucatán; mismo en el que obran nuestras oficinas
              principales y que se señala para la recepción de todo tipo de notificaciones y avisos. El representante
              legal de BIENES RAÍCES YUCATÁN PREMIER S.A. DE C.V. es el C. Mauricio José Medina Bautista.
            </Statement>
          </Section>
        </Col>
        <Col md={6}>
          <Section>
            <Text>
              <strong>En BIENES RAÍCES YUCATÁN PREMIER S.A. DE C.V.,</strong> como parte de nuestras actividades
              comerciales solicitamos determinados datos personales de nuestros clientes para la realización de los
              servicios requeridos, así como para la expedición de recibos y contratos, los datos a solicitar incluyen
              algunos o todos de los siguientes: nombre, domicilio, teléfono fijo y celular, correo electrónico, RFC,
              firma autógrafa, números de cuentas bancarias, videos de quienes ingresan que son registrados en la cámara
              de seguridad de la empresa. De igual forma se hace saber a nuestros clientes que no solicitamos ningún
              dato personal sensible.
            </Text>
            <Text>
              La finalidad con la que recabamos los datos anteriormente mencionados es únicamente la de llevar a cabo la
              comisión que nos sea encomendada, es decir, la elaboración de contratos, facturas, recibos de pago y demás
              documentación relacionada con el mandato. Informamos por este medio a nuestros clientes que no se
              realizará ninguna transferencia de datos ni serán utilizados para fines distintos a los especificados en
              el presente aviso de privacidad.
            </Text>
            <Text>
              Sus datos personales son guardados por medios electrónicos avanzados que permiten su debida protección de
              todo acceso no autorizado. El titular del departamento de protección de datos personales es el C. MICHAEL
              FELIX ROSADO SALERNO y se localiza en el mismo domicilio de nuestras oficinas.
            </Text>
            <Text>
              Así mismo se le hace saber a nuestros clientes que para el ejercicio de los derechos ARCO (acceso,
              rectificación, cancelación y oposición) de nuestros clientes ponemos a su disposición el correo
              electrónico <a href="mailto:info@yucatanpremier.com">info@yucatanpremier.com</a> al cual podrá comunicarse
              para hacer la solicitud correspondiente y de la que recibirá respuesta por el mismo medio en un plazo no
              mayor a diez días hábiles. Este mismo mecanismo será aplicado para el caso de la revocación de uso de
              datos.
            </Text>
            <Text>
              Hacemos del conocimiento de nuestros clientes que, para el caso de revocación, no todos sus datos podrán
              ser eliminados de manera inmediata, esto debido a distintos ordenamientos de índole fiscal, administrativo
              o comercial que dicte la legislación vigente.
            </Text>
            <Text>
              Toda modificación que se realice al presente aviso de privacidad será notificada por medio de la página de
              internet <a href="http://yucatanpremier.com">yucatanpremier.com</a>, donde podrá consultarlo libremente.
            </Text>
          </Section>
          <Section>
            <h6>CONTACTO</h6>
            <Text>
              Si tiene preguntas sobre su privacidad cuando utilice el Sitio Web, por favor contáctenos a los siguientes
              correos electrónicos:
            </Text>
            <Text>
              Mexico: <a href="mailto:info@yucatanpremier.com">info@yucatanpremier.com</a>
            </Text>
          </Section>
        </Col>
      </Row>
    </Container>
  </Wrapper>
)
